import { YearSelector } from "../../../../components";
import { Box, Flex, Text, useBreakpointValue, useToast } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  useGetScopeThreeConversionFactors
} from "../../../../hooks/query/conversion-factors";
import { showErrorToast } from "../../../../utils";
import { CategorySelector, ScopeThreeFactorsGrid } from "./index";

function ScopeThreeFactorsTab({ selectedYear, setSelectedYear }) {
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const selectorFlow = useBreakpointValue({
    sm: "row",
    base: "column"
  });

  const [selectedCategory, setSelectedCategory] = useState("categoryOne");

  const {
    data: scopeThreeFactorsData
  } = useGetScopeThreeConversionFactors({
    year: selectedYear
  }, {
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <Box>
      <Flex gap={selectorFlow === "row" ? 4 : 0} flexFlow={selectorFlow}>
        <YearSelector selectedYear={selectedYear} handleYearSelection={(value) => setSelectedYear(value)} />
        <CategorySelector
          selectedCategory={selectedCategory}
          handleCategorySelection={(value) => setSelectedCategory(value)}
        />
      </Flex>
      {!scopeThreeFactorsData || Object.keys(scopeThreeFactorsData)?.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <ScopeThreeFactorsGrid data={scopeThreeFactorsData} selectedCategory={selectedCategory} />
      }
    </Box>
  );
}

export default ScopeThreeFactorsTab;